import { combineReducers } from 'redux';

import apiCallsInProgress from './apiStatusReducer';
import login from './loginReducer';
import alert from './alertReducer';
import configuracao from './configuracaoReducer';
import menu from './menuReducer';
import novoFiltro from './novoFiltroReducer';
import migalha from './migalhaReducer';

const rootReducer = combineReducers({
    apiCallsInProgress,
    login,
    alert,
    configuracao,
    menu,
    novoFiltro,
    migalha
});

export default rootReducer;
